import { type Instrument, type Timeframe, VENUES } from "@trader/shared/MarketData"
import type { ChartContext } from "lightweight-charts-indicators"

// What the indicators know about the chart (as TradingView gives Pine scripts):
// the interval, the exchange timezone and session, the tick. Session-anchored
// indicators (VWAP, pivots) use them to reset at the exchange's day.

const PINE_TIMEFRAME: Readonly<Record<Timeframe, string>> = {
  "1m": "1",
  "3m": "3",
  "5m": "5",
  "15m": "15",
  "1h": "60",
  "4h": "240",
  "1D": "1D"
}

/** "09:15"/"15:30" sessions → Pine's "0915-1530" (comma-separated for lunch breaks). */
const pineSession = (instrument: Instrument): string =>
  VENUES[instrument.venue].sessions
    .map((session) => `${session.open.replace(":", "")}-${session.close.replace(":", "")}`)
    .join(",")

export const chartContextFor = (instrument: Instrument, timeframe: Timeframe): ChartContext => ({
  timeframe: PINE_TIMEFRAME[timeframe],
  timezone: VENUES[instrument.venue].timezone,
  session: pineSession(instrument),
  tickerid: instrument.id,
  mintick: instrument.tickSize,
  symbolType: instrument.kind === "index" ? "index" : "stock",
  currency: instrument.currency,
  lastBarConfirmed: false
})
